// @ts-nocheck
import React, { useCallback } from 'react';
import { FilterItem } from '../../../../components';
import Field from '../../../../components/card/Field';
import { CommonFilter } from '../../../../components/hoc/common/handbook/CommonFilter';
import { Selects } from '../../../../components';
const {
  PddTestSelect
} = Selects;
export const PddTestRegisterFilter = props => {
  const Filter = useCallback(filterProps => CommonFilter({
    ...filterProps,
    ...props
  }), [props]);
  return <Filter>
      {(values, changeValue) => <>
          <FilterItem>
            <Field mBottomNone>
              <PddTestSelect size="small" value={values.pddTestId} onChange={e => changeValue('pddTestId', e.target.value)} placeholder="Выберите тест" />
            </Field>
          </FilterItem>
        </>}
    </Filter>;
};
export default PddTestRegisterFilter;
